import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import ChangePasswordForm from "../../features/account/changePasswordForm"
import useAuth from "@/hooks/useAuth"
import { AuthenticationMethod } from "@/types"
import Callout from "@/components/callout/callout"

const SecuritySettingsPage = () => {

    const { t } = useTranslation()
    const { getAuthenticationMethod } = useAuth()

    return (
        <>
            <PageTitle title={t('titleSecuritySettings')} />
            
            {getAuthenticationMethod === AuthenticationMethod.password ? (
                <Section>
                    <ChangePasswordForm />
                </Section>
            ) : getAuthenticationMethod === null ? (
                <Section>
                    <div className="animate-pulse bg-gray-200 h-8 rounded"></div>
                </Section>
            ) : (
                <Section>
                    <Callout type="info">
                        {t('passwordChangeUnavailable')}
                    </Callout>
                </Section>
            )}
            
            <RightSidebar />
        </>
    )
}

export default SecuritySettingsPage

